<template>
    <div style="height:100%">
        <v-card class="nav-menu-header bg-main" elevation="8">
        <div>
            <v-btn icon class="nav-close-btn"  @click="closeNavMenu">
                <v-icon class="whiteIcon"> 
                {{ icons.mdiClose}}
                </v-icon>
            </v-btn>
        </div>
        <div >
            <div class="nav-menu-header-logo">
            <img :src="homelogo" />
            <h1>{{FASTORDER}}</h1>
            </div>
        </div>
        </v-card>
        <div class="nav-menu-icon">
        <v-card flat class="nav-menu-cont">
            <v-icon class="navIcon-color1" large>
            {{ icons.mdiHome }}
            </v-icon>
            <v-card-subtitle class="nav-menu-icon-text">
            MENU
            </v-card-subtitle>
        </v-card>
        <div class="nav-menu-content-container">

            <v-btn v-if="isLogin" tile text class="btn-nav" @click="userAddressList">
            <v-icon class="btn-nav-icon navIcon-color2">
                {{ icons.mdiMapMarker }}
            </v-icon>
            <v-card-subtitle class="btn-nav-text">
                My Addresses
            </v-card-subtitle>
            </v-btn>
            <v-btn v-if="!isLogin" tile text class="btn-nav" @click="userSso">
            <v-icon class="btn-nav-icon navIcon-color3">
                {{ icons.mdiLoginVariant }}
            </v-icon>
            <v-card-subtitle class="btn-nav-text">
                Login / Register
            </v-card-subtitle>
            </v-btn>
            <v-btn v-if="isLogin" text tile class="btn-nav" @click="userProfile" >
            <v-icon class="btn-nav-icon navIcon-color4">
                {{ icons.mdiAccountDetails}}
            </v-icon>
            <v-card-subtitle class="btn-nav-text">
                Profile
            </v-card-subtitle>
            </v-btn>
            <v-btn v-if="isLogin" tile text class="btn-nav" @click="toMyOrder">
            <v-icon class="btn-nav-icon navIcon-color5">
                {{ icons.mdiMessageTextClock }}
            </v-icon>
            <v-card-subtitle class="btn-nav-text"> 
                Order History
            </v-card-subtitle>
            </v-btn>
            <v-btn v-if="isLogin" tile text class="btn-nav" @click="userLogout">
            <v-icon class="btn-nav-icon navIcon-color6">
                {{ icons.mdiLoginVariant }}
            </v-icon>
            <v-card-subtitle class="btn-nav-text">
                Logout
            </v-card-subtitle>
            </v-btn>
            <v-card flat>
            <v-list>
                <span style="margin-left:10px" class="btn-nav-text">SETTINGS</span>
            </v-list>
            </v-card>
            <v-card flat class=" mr-5">
            <v-list style="padding:0">
                <v-list-group color="red">
                <template v-slot:activator >
                    <v-list-item style="padding:0;margin:0">
                    <v-list-item-title class="btn-nav-text">
                        <v-icon class="navIcon-color7" style="margin-right:10px">
                        {{ icons.mdiTranslate }}
                        </v-icon>
                        LANGUAGE
                    </v-list-item-title>
                    </v-list-item>
                </template>
                <SelectLocale /> 
                </v-list-group>
            </v-list>
            </v-card>
            <v-card flat class="mr-5">
            <v-list>
                <v-list-group  class="navIcon-color7">
                <template v-slot:activator>
                    <v-list-item style="padding:0;margin:0">
                    <v-list-item-title class="btn-nav-text">
                        <v-icon class="navIcon-color8" style="margin-right:10px">
                        {{ icons.mdiMessageBulleted}}
                        </v-icon>
                        FEEDBACK
                    </v-list-item-title>
                    </v-list-item>
                </template>
                    <v-list-item>
                    <v-list-item-title style="text-align:center" class="btn-nav-text greenIcon">
                        Chat Us on Whatsapp
                        <v-icon class="greenIcon" style="margin-left:10px">
                        {{ icons.mdiWhatsapp }}
                        </v-icon>
                    </v-list-item-title>
                    </v-list-item>
                </v-list-group>
            </v-list>
            </v-card>
        </div>
        <v-card v-if="isLogin" elevation="18" class="mt-auto btn-nav-user" >
            <v-card flat class="btn-nav-user-content bg-main">
            <v-icon class="whiteIcon" large>
                {{ icons.mdiAccountCircle }}
            </v-icon>
            <span>Username</span>
            <v-icon class="whiteIcon" style="margin-left:auto;">
                {{ icons.mdiDotsVertical }}
            </v-icon>
            </v-card>
        </v-card>
        </div>
    </div>
</template>
<script>
import { 
    mdiPencil,
    mdiCloseCircleOutline,
    mdiDotsVertical ,
    mdiClose,
    mdiChevronDown,
    mdiAccountDetails,
    mdiTranslate,
    mdiArrowLeftCircle,
    mdiAccountCircle,
    mdiMessageBulleted,
    mdiLoginVariant ,
    mdiMessageTextClock ,
    mdiCogs ,
    mdiHome,
    mdiMapMarker ,
    mdiWhatsapp 
} from '@mdi/js';

import i18n from '../../locales/index'
import homelogo from "@/assets/logo.png"
// import SelectLocale from '../../locales/SelectLocale.vue'
import { mapGetters} from 'vuex'
import { FASTORDER } from '@/constants'

export default {
components: {
    SelectLocale: () => import(/* webpackChunkName: "selectLocale" */ "../../locales/SelectLocale.vue"),
},
props: {
    required: {
        type: Boolean,
        required:false,
        default: undefined
    },
    is_scene_code: {
        type: Boolean,
        required:false,
        default: undefined
    },
    order_id: {
        type: Number,
        required:false,
        default: undefined
    },
    isLogin: {
        type: Boolean,
        required:false,
        default: undefined
    }
},
data () {
    return {
    FASTORDER,
    group: null,
    icons: {
        mdiPencil,
        mdiAccountCircle,
        mdiDotsVertical ,
        mdiArrowLeftCircle,
        mdiCloseCircleOutline,
        mdiClose,
        mdiTranslate,
        mdiChevronDown,
        mdiAccountDetails,
        mdiMessageBulleted,
        mdiLoginVariant ,
        mdiMessageTextClock ,
        mdiCogs ,
        mdiHome,
        mdiMapMarker ,
        mdiWhatsapp 
    },
    isHome: true,
    homelogo: homelogo
    }
},
created() {
    console.log('user isLogin ==>',this.user_islogin)
},
computed: {
    ...mapGetters(["user_islogin"]),
},

methods: {
    changeLocale(locale) {
        i18n.locale = locale;
    },
    closeNavMenu(){
        this.$emit('evtCloseNavMenu')
    },

    toMyOrder () {
        this.$emit("evtToMyOrder")
    },

    userSso () {
        this.$emit("evtUserSSO")
    },
    
    userProfile () {
        this.$emit("evtUserProfile")
    },

    userLogout () {
        this.$emit("evtUserLogout")
    },
    tablesDineinOrderDetail (){
        this.$emit("evtDineinOrderDetail")
    },
    userAddressList() {
        let lang = window.location.hash.split("&").filter((string)=> string.includes("lang="))[0].split("=")[1]
        if (this.user_islogin) {
        this.$router.push({ path: '/user/addressList',query: {"lang":`${decodeURIComponent(lang)}`}})
        } else {
        const url = {
            path: "/user/addressDetail",
            query: {"address_id": 0,"lang":`${decodeURIComponent(lang)}`}
        };
        this.$router.push(url);
        }
    }

}
}

</script>
<style lang="less">
@import url('../../assets/css/common.less');

.nav-menu-header{
    padding:10px 20px 20px !important;
    font-family: roboto,sans-serif;
    margin-bottom:30px!important;
    border-radius:0px 0px 30px 0px !important;
    font-size: 15px;
    @media screen and (max-width:600px){
        margin-bottom:20px!important;
        padding:14px !important;
    }
}

.nav-close-btn{
    display:block !important;
    margin-left:auto;
        @media screen and (max-width:600px){
        position: absolute !important;
        right:10px;
        top: 15px;
    }
}

.nav-menu-header-logo{
    display:flex;
    align-items:center;
    justify-content:center;
    img{
        height: 50px;
        @media screen and (max-width:600px){
        height: 35px;
        }
    }
    h1{
        margin-left: 10px;
        @media screen and (max-width:600px){
        font-size: 18px;
        }
    }
}

.nav-menu-icon{
    height: 100% !important;
    max-height:calc( 100% - 146px) !important;
    display:flex !important;
    flex-direction:column !important;
    @media screen and (max-width:600px){
        max-height:calc( 100% - 83px) !important;
    }
}

.nav-menu-cont{
    display:flex !important;
    justify-content:center !important;
    align-items: center !important;
    margin-bottom: 10px;
}
.nav-menu-icon-text{
    padding:10px 0 10px 10px !important;
    font-size:18px !important;
    font-weight:bold !important;
    @media screen and (max-width:600px){
        font-size: 13px !important;
        font-weight:400 !important;
        }
}

.nav-menu-content-container{
    display:flex !important;
    flex-direction:column !important;
    padding:0 20px !important;

}


.btn-nav{
    justify-content: flex-start !important;
    padding: 25px 10px !important;
    @media screen and (max-width:600px){
        padding: 15px 10px !important;
    }
}
.btn-nav-icon{
    @media screen and (max-width:600px){

    }
}
.btn-nav-text{
    font-size: 16px !important;
    font-family: roboto;
    @media screen and (max-width:600px){
        font-size: 12px !important;
    } 
}

.btn-nav-user{
    border-radius:15px 15px 0 0 !important;
    
}
.btn-nav-user-content{
    height: 60px !important;
    display:flex !important;
    align-items:center !important;
    justify-content:flex-start !important;
    padding:10px 20px 10px 20px !important;
    span{
        margin-left: 10px;
    }
    @media screen and (max-width:600px){
        padding: 0px 20px 0px 20px !important;
    } 
}

</style>